export default __webpack_public_path__ + "static/media/reply_icon.aab98f54.svg";